/**
 * @file index.tsx
 * @description Public entry point for the shared extraction-view atom.
 *   Consumed by the desktop drawer, mobile page, and PR C Financials
 *   tab.
 * @module features/contracts/components/ContractExtractionView
 */

export { default } from "./ContractExtractionViewContainer";
export type { ContractExtractionViewContainerProps } from "./ContractExtractionViewContainer";
